<template>
<div class="control" @click.stop>
	<ul class="commands">
		<li>
			<button @click.stop="command('undo')" class="prev icon-prev">이전</button>
			<button @click.stop="command('redo')" class="next icon-next">다음</button></li>
		<li>
			<select class="fontFamily" v-model="fontFamily" name="font" id="">
				<option value="NanumSquare" selected="selected">NanumSquareRound1</option>
				<option value="serif">serif</option>
				<option value="cursive">cursive</option>
			</select>
			<div class="fontSize">
				<button @click="fontSizeChange('minus')">-</button>
				<input type="number" @blur="fontSizeChange()" v-model="fontSize" value="12">
				<button @click="fontSizeChange('add')">+</button>
			</div>
		</li>
		<li>
			<button @click.stop="command('toggleBold')" class="bold icon-bold">bold</button>
			<button @click.stop="command('toggleItalic')" class="italic icon-italic">italic</button>
			<button @click.stop="command('toggleUnderline')" class="underline icon-underlined">underline</button>
			<button @click.stop="command('toggleStrike')" class="middleline icon-del">middleline</button>
			<button @click.stop="openColor('text')" class="color icon-under-bold-1" :style="{color:textColor}">color</button>
			<button @click.stop="openColor('highlight')" class="bg icon-background-color" :style="{backgroundColor:highlightColor}">background</button>
			<button @click.stop="command('toggleSubscript')" class="tt icon-under">transform top</button>
			<button @click.stop="command('toggleSuperscript')" class="tt icon-upper">transform bottom</button>
			<button @click="resetStyle" class="reset icon-erase">reset</button>
		</li>
		<li>
			<button @click.stop="command('toggleBulletList')" class="list icon-view-list">list</button>
			<button @click.stop="command('toggleOrderedList')" class="listNumber icon-list-ordered">list number</button>
			<button class="insert icon-text-indent-right">tab insert</button>
			<button class="indent icon-text-indent-left">tab</button>
			<button @click.stop="command('setTextAlign', 'left')" class="al icon-align-left">align left</button>
			<button @click.stop="command('setTextAlign', 'center')" class="ac icon-align-center">align center</button>
			<button @click.stop="command('setTextAlign', 'right')" class="ar icon-align-right">align right</button>
			<label class="image icon-image">
				<input @change="imageUpload" type="file">
				add image
			</label>
		</li>
	</ul>
	<div class="util">
		<div class="keywordSearch">
			<button>단어검색</button>
			<ul class="keywordList">
				<li @click.stop="openKeywordPopup('재료', 'MATERIAL')">재료</li>
				<li @click.stop="openKeywordPopup('공정', 'PROCESS')">공정</li>
				<li @click.stop="openKeywordPopup('측정목적', 'MEASUREMENT')">측정목적</li>
				<li @click.stop="openKeywordPopup('분석목적', 'ANALYSIS')">분석목적</li>
				<li @click.stop="openKeywordPopup('장비', 'EQUIPMENT')">장비</li>
			</ul>
		</div>
		<div class="unitSearch">
			<button @click="updateStatus({'unitProtocol': true})">유닛프로토콜 검색</button>
		</div>
		<button class="save" @click="saveContent">저장하기</button>
	</div>
	<div class="colorPicker" v-show="colorPicker">
		<Chrome v-model="colors" @input="colorChange"></Chrome>
		<Compact v-model="colors" @input="colorChange"></Compact>
	</div>
</div>
</template>

<script>
import {Photoshop, Chrome, Swatches, Compact} from 'vue-color'
import { TagAddPopCommMapMutations } from "@TagAddPop/TagAddPopComm"; 
// import TagOptionPopTagAddList from '@components/TagAddPop/TagOptionPopTagAddList' ; 
import CommNew, {commNewMapMutations, commNewMapGetters} from "@processEditor/CommNew";
import ('../../style/css/process-icon.css');

let colors = {
  hex: '#194d33',
  hex8: '#194D33A8',
  hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
  hsv: { h: 150, s: 0.66, v: 0.30, a: 1 },
  rgba: { r: 25, g: 77, b: 51, a: 1 },
  a: 1
}

export default {
	components: {
		Photoshop, Chrome, Swatches, Compact,
	},
	mixins: [CommNew],
	props: {
		editor: Object,
	},
	data () {
		return {
			mode: false,
			colors,
			colorTarget: {
				target: '',
				color:''
			},
			textColor:'',
			highlightColor: '#fff',
			colorPicker: false,
			fontFamily: 'NanumSquare',
			fontSize: 12
		}
	},
	watch: {
		editor (value) {
			console.log('Watch editor : ', value, value.constructor)
			if(value.constructor === NamoSE) {
				console.log('Editor type namo')
			}
		},
		fontFamily(value) {
			console.log('Watch font family : ', value)
			if(!this.editor) return
			this.editor.chain().focus().setFontFamily(value).run()
		},
		// fontSize(value) {
		// 	this.editor.chain().focus().setFontSize(value).run()
		// }
	},
	methods: {
		...commNewMapMutations(['updateStatus']),
		...TagAddPopCommMapMutations([
      'setTagOptionPopAddListViewBln' , 
      'setCrntTagType' , 
      'setCallbackFunc' , 
    ]) ,
		command(key, option=null) {
			this.editor.chain().focus()
			console.log(key, option, this.editor.commands)
			// this.editor.commands[key](option)
			this.editor.chain().focus()[key](option).run()
		},
		openColor(type) {
			let getColor
			if(type=='text') {
				getColor = this.editor.getAttributes('textStyle').color
				this.colorChange = this.textColorChange
			} else {
				getColor = this.editor.getAttributes('highlight').color
				this.colorChange = this.highlightColorChange
			}
			console.log(getColor);
			// if(!getColor){
			// 	this.editor.commands.setColor('#333')
			// }
			this.colorPicker = true
			window.removeEventListener('click', this.closeColorPicker)
			window.addEventListener('click', this.closeColorPicker)

		},
		resetStyle(e) {
			const styles = [
				'Bold',
				'Italic',
				'Underline',
				'Strike',
				'Color',
				'Highlight',
				'Subscript',
				'Superscript'
			]
			for(const style of styles) {
				this.editor.commands[`unset${style}`]()
			}
		},
		fontSizeChange(type) {
			if(!this.editor) return;
			this.fontSize = Number(this.fontSize)
			if(type === 'add') this.fontSize = Math.min(this.fontSize + 1, 80)
			if(type === 'minus') this.fontSize = Math.max(0, this.fontSize - 1)
			this.editor.chain().focus().setFontSize(this.fontSize).run()
		},
		closeColorPicker(e) {
			console.log('Close color picker : ')
			this.colorPicker = false	
			window.removeEventListener('click', this.closeColorPicker)
		},
		textColorChange (e) {
			if(!this.colorPicker) return
			this.editor.chain().focus().setColor(e.hex).run()
			this.textColor = e.hex
			// console.log('Text color: ', this.textColor)
		},
		highlightColorChange (e) {
			if(!this.colorPicker) return
			// this.editor.chain().focus().toggleHighlight({ color: e.hex }).run()
			if(e.hex === '#FFFFFF') {
				this.editor.chain().focus().unsetHighlight().run()
			} else {
				this.editor.chain().focus().setHighlight({ color: e.hex }).run()
			}
			// this.highlightColor = e.hex
			// console.log('Hightlight color : ', this.highlightColor)
		},
		colorChange(e) {},
		imageUpload(e) {
			let file = e.target.files
			const reader = new FileReader();
			reader.readAsDataURL(file[0])
			reader.onload = () => {
				this.editor.commands.setImage({src:reader.result})
			}
		},
		saveContent() {
			this.$emit('save', this.editor)
		},
		openKeywordPopup(label, type) {
			this.setCallbackFunc( (info)=>{
				this.editor.commands.insertContent(info.name);
				this.editor.chain().focus();
			} ) ;
			this.setCrntTagType({ tag : {
          name : label , 
          type : type , 
      }}) ; 
			this.setTagOptionPopAddListViewBln({ bln : true })
		}
	}
}
</script>

<style lang="scss" scoped>
.keywordSearch {
	position: relative;
	&:hover {
		ul.keywordList {
			visibility: visible;
		}
	}
	button {
		display: inline-flex; align-items: center; justify-content: center;
		height: 100%;
		padding: 0 16px;
		font-size: 14px;
		color: $dark-blue;	
	}
	ul.keywordList {
		visibility: hidden;
		display: flex; flex-direction: column;
		position: absolute;
		padding: 8px;
		border: 1px solid $dark-blue;
		background-color: #fff;
		li {
			width: 100%;
			padding: 8px;
			white-space: nowrap;
			color: $dark-blue;
			&:hover {
				cursor: pointer;
				background-color: #eee;
			}
		}
	}
}

.unitSearch {
	button {
		display: flex; align-items: center;
		padding: 0 16px;
		color: $dark-blue;
		font-size: 14px;
		&:after {
			content: '';
			width: 14px; height: 14px;
			margin-left: 10px;
			background: url('../../assets/icons/magnify_blue.svg') center no-repeat;
			background-size: 100%;
		}
	}
}
.control {
	display: inline-flex; align-items: center; 
	// position: sticky; top: -20px;
	position: sticky; top: 0px;
	width: 100%; 
	// max-width: 1160px;
	// padding: 18px 10px;
	padding: 9px 40px 9px 250px;
	border-radius: 4px;
	box-shadow: 0px 2px 8px rgba(91, 91, 91, 0.3);
	background-color: #fff;
	z-index: 1;
	ul.commands {
		button[class*="icon-"] {
			width: 24px; height: 24px;
			font-size: 0;
			&::before {
				font-size: 20px;
			}
			// &.color::before {
			// 	text-shadow: 1px 1px 1px #333 !important;
			// }
		}
	}
	div.util {
		display: flex; align-items: center;
		margin-left: auto;
		> div { height: 20px; }
		div + div {
			border-left: 1px solid #ddd;
		}
	}
	button.save {
		width: 80px; 
		min-height: 33px;
		flex-shrink: 0; 
		padding: 8px 0px;
		border-radius: 5px;
		
		background-color: $dark-blue;
		color: #fff;
		@include text-prt; 
		font-size: 14px; 
	}
	label.image {
		display: inline-flex; align-items: center;
		overflow: hidden;
		font-size: 0;
		&::before {
			font-size: 20px;
		}
		input {
			visibility: hidden;
		}
	}
	ul.commands {
		display: flex; gap: 8px; align-items: center;
		li {
			display: flex; gap: 8px;
		}
	}
	.colorPicker {
		position: absolute; top: 100%; left: 480px;
		width: 220px;
		box-shadow: 0 0 2px rgb(0 0 0 / 30%), 0 4px 8px rgb(0 0 0 / 30%);
		.vc-chrome {
			width: 220px;
			box-shadow: none;
		}
		.vc-compact {
			width: 220px;
			padding: 10px;
			box-shadow: none;
		}
	}
	.fontFamily {
		height: 30px;
		padding: 5px 30px 5px 8px;
		border-radius: 3px;
		border: 1px solid #ced4da;
		font-size: 13px;
		option {
			padding: 4px;
		}
	}
	.fontSize {
		display: inline-flex; align-items: center;
		box-sizing: border-box;
		height: 30px;
		font-size: 13px;
		border: 1px solid #ced4da;
		input {
			width: 50px;
			border: none;
			text-align: center;
			-webkit-appearance: textfield;
			&::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
				-webkit-appearance: none;
  			margin: 0;
			}
		}
		button {
			width: 30px; height: 30px;
			cursor: pointer;
		}
	}
}
</style>



